import Mutations from '../../odata/mutations';

export default { ...new Mutations('stockItem'), ...new Mutations('stockItems'), ...new Mutations('processingStockItems') };
